// <!-- ============================================================================= -->
// <!-- Ella Custom JS - Customize The Style For Layout -->
// <!-- ============================================================================= -->

// <!-- ============================================================================= -->
// <!-- IMPORTANT DISCLAIMER -->
// <!-- Please use only JS to style the layout. -->
// <!-- ============================================================================= -->

$(".client--slider .slide-track").slick({
  //   mobileFirst: true,
  //   adaptiveHeight: true,
  infinite: true,
  slidesToShow: 4,
  autoplay: true,
  pauseOnHover: false,
  arrows: false,
  variableWidth: true,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
  ],
});
